<template>
  <v-container id="player-battle">
    <dice class="first-dice" :input="firstDiceInput" @clicked="throwFirstDice"></dice>
    <div class="first-name name">{{ firstName }}</div>
    <div class="second-name name">{{ secondName }}</div>
    <dice class="second-dice" :input="secondDiceInput" @clicked="throwSecondDice"></dice>
    <v-fade-transition>
      <div class="popup-dialog" v-show="firstThrow != null && secondThrow != null && firstThrow === secondThrow" @click.stop="reset">
        <div class="content">
          <span class="text gradient-text">Throw again</span>
        </div>
      </div>
    </v-fade-transition>
    <v-fade-transition>
      <div class="popup-dialog" v-show="!!loser" @click.stop="$emit('finish', loser)">
        <div class="content" v-if="loser">
          <span class="text gradient-text">{{ loser.name }} lost!</span>
        </div>
      </div>
    </v-fade-transition>
  </v-container>
</template>

<script>
import Dice from './Dice';

export default {
  name: 'player-battle',
  props: {
    battle: Object
  },
  components: {
    'dice': Dice
  },
  data: () => ({
    firstThrow: null,
    secondThrow: null
  }),
  mounted () {
    if (localStorage.firstThrow) this.firstThrow = localStorage.firstThrow;
    if (localStorage.secondThrow) this.secondThrow = localStorage.secondThrow;
  },
  watch: {
    battle () {
      this.reset();
    },
    firstThrow (newValue) { 
      localStorage.firstThrow = newValue;
    },
    secondThrow (newValue) { 
      localStorage.secondThrow = newValue;
    }
  },
  computed: {
    firstName () { return this.battle && this.battle.firstPlayer ? this.battle.firstPlayer.name : '' },
    secondName () { return this.battle && this.battle.secondPlayer ? this.battle.secondPlayer.name : '' },
    firstDiceInput () { return this.firstThrow ? { number: this.firstThrow } : null },
    secondDiceInput () { return this.secondThrow ? { number: this.secondThrow } : null },
    loser () {
      if (!this.battle || this.firstThrow === null || this.secondThrow === null || this.firstThrow === this.secondThrow) {
        return null;
      }

      return this.firstThrow < this.secondThrow ? this.battle.firstPlayer : this.battle.secondPlayer;
    }
  },
  methods: {
    throwFirstDice () {
      if (!this.firstThrow) {
        this.firstThrow = Math.floor((Math.random() * 6) + 1);
      }
    },
    throwSecondDice () {
      if (!this.secondThrow) {
        this.secondThrow = Math.floor((Math.random() * 6) + 1);
      }
    },
    reset () {
      this.firstThrow = null;
      this.secondThrow = null;
    }
  }
};
</script>